<button mat-menu-item class="dropdown-menu-item"
    [ngClass]="{'disabled': disabled, 'text-blue-hover': !disabled}">
  <i *ngIf="icon && !isMaterialIcon" [ngClass]="icon"></i>
  <mat-icon *ngIf="icon && isMaterialIcon">{{ icon }}</mat-icon>
  <span class="light" [translate]="text"></span>
</button>
